import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import handleInsertRole from '../utils/insertRole';

import deleteRole from './deleteRole';
import roleExport from './roleExport';
import Actions from '../../../../../../../../../store/actions';
import SnackBarAlerts from '../../../../../../../../common/snackBarAlerts/snackBarAlerts';
import {
  RoleDetailsWrapper,
  RoleChildren,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/roleDetails';
import dragStart from './onDragStart';
import dragEnd from './onDragEnd';
import RoleLabel from './roleLabel';

class RoleDetails extends Component {
  constructor(props) {
    super(props);

    const {
      nodeProps: {
        node: { data: currData },
      },
    } = this.props;
    const toExport = currData.get('toExport');

    this.state = {
      isExported: toExport,
      currentCollapse: false,
      noDrag: false,
      snackBar: null,
    };
  }

  componentDidUpdate = (prevProps) => {
    const { prevExport, currExport } = this.getHistoryProps(prevProps);

    if (prevExport !== currExport) this.setState({ isExported: currExport });
  };

  getHistoryProps(prevProps) {
    const {
      nodeProps: {
        node: { data: prevData },
      },
    } = prevProps;
    const {
      nodeProps: {
        node: { data: currData },
      },
    } = this.props;
    const prevExport = prevData.get('toExport');
    const currExport = currData.get('toExport');
    return { prevExport, currExport };
  }

  setExport = (val) => this.setState({ isExported: val });

  handleExport = (e) => {
    e.preventDefault();

    const {
      nodeProps: { editor, node: currentRole },
    } = this.props;
    const { data, key: roleKey } = currentRole;
    const { isExported } = this.state;

    roleExport({
      data,
      editor,
      currentRole,
      roleKey,
      setExport: this.setExport,
      isExported,
    });
  };

  handleDelete = (e) => {
    e.preventDefault();

    const {
      nodeProps: { editor, node: currentRole },
    } = this.props;

    deleteRole({ editor, currentRole });
  };

  insertRole = (e) => {
    const {
      nodeProps: { editor, node: currentRole },
    } = this.props;
    handleInsertRole(e, editor, currentRole, null, this.props);
  };

  onDragStart = (e) => {
    const { noDrag } = this.state;
    const { nodeProps, collapse, setCollapse } = this.props;

    const nativeSelection = window.getSelection().toString().length;
    if (nativeSelection) {
      e.preventDefault();
      return;
    }

    setTimeout(() => {
      const { editor } = nodeProps;
      const {
        value: {
          document: { nodes },
        },
      } = editor;
      const orgNodesArray = nodes.toArray();
      orgNodesArray.forEach((orgNode) => {
        const { key: orgKey, data: orgData } = orgNode;
        const orgDataJSON = orgData.toJSON();
        const { isCollapseChildren } = orgDataJSON;
        if (isCollapseChildren) {
          editor
            .setNodeByKey(orgKey, {
              data: {
                ...orgDataJSON,
                isCollapseChildren: false,
              },
            })
            .blur();
        }
      });
    });

    dragStart({
      e,
      noDrag,
      nodeProps,
      collapse,
      setCollapse,
      setSnackBar: this.setSnackBar,
      setDrag: this.setDrag,
    });
  };

  onDragEnd = (e) => {
    const { snackBar } = this.state;
    const { nodeProps, collapse, setCollapse, dragOverCords } = this.props;
    dragEnd({
      e,
      snackBar,
      nodeProps,
      collapse,
      setCollapse,
      setSnackBar: this.setSnackBar,
      dragOverCords,
    });
  };

  setDrag = (val) =>
    this.setState({
      noDrag: val,
    });

  stopDrag = () => this.setDrag(true);

  setSnackBar = (type) => {
    if (type === 'error')
      this.setState({
        snackBar: {
          showSnackBar: true,
          snackBarMessage: 'Please, retry the dragging!',
          snackBarType: 'error',
          errorCode: 'drag',
        },
      });
  };

  render() {
    const { currentCollapse, snackBar } = this.state;
    const {
      nodeProps,
      placeHolder,
      collapse: { document },
      dragType,
    } = this.props;
    const { node: currentRole, attributes, children } = nodeProps;

    /**
     * Collapse cards state
     */
    const { editor } = nodeProps;
    const {
      value: {
        document: { key: documentKey },
      },
    } = editor;
    const { [documentKey]: documentCollapse } = document || {};

    const collapseRole =
      (documentCollapse && dragType === 'ROLE') || currentCollapse;

    const isCollapseChildren =
      (currentRole && currentRole.data.get('isCollapseChildren')) || false;

    return (
      <>
        {snackBar && (
          <SnackBarAlerts
            showSnackBar={snackBar.showSnackBar}
            handleClose={this.handleCloseSnackBar}
            snackBarMessage={snackBar.snackBarMessage}
            snackBarType={snackBar.snackBarType}
          />
        )}
        <RoleDetailsWrapper
          {...attributes}
          className="role-details"
          draggable
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
          isCollapseChildren={isCollapseChildren}
        >
          <RoleLabel
            placeHolder={placeHolder}
            currentRole={currentRole}
            stopDrag={this.stopDrag}
            handleExport={this.handleExport}
            handleDelete={this.handleDelete}
            insertRole={this.insertRole}
            editor={editor}
            isCollapseChildren={isCollapseChildren}
          />
          {!collapseRole && (
            <RoleChildren
              onMouseDown={this.stopDrag}
              isCollapseChildren={isCollapseChildren}
            >
              {' '}
              {children}
            </RoleChildren>
          )}
        </RoleDetailsWrapper>
      </>
    );
  }
}

RoleDetails.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  attributes: propTypes.objectOf(propTypes.string).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func.isRequired,
  }).isRequired,
  placeHolder: propTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  collapse: state.editResumeFormReducer.collapse,
  dragType: state.editResumeFormReducer.dragType,
  dragOverCords: state.editResumeFormReducer.dragOverCords,
  universityPlan: state.userInfoReducer.universityPlan,
});
const mapDispatchToProps = (dispatch) => ({
  setCollapse: (params) =>
    dispatch(Actions.editResumeFormActions.setCollapse(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleDetails);
